import React from 'react';
import {Chip} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';

export const BankAccountValidationDisplay: React.FC<{isValidated: boolean}> = ({
  isValidated,
}) =>
  isValidated ? (
    <Chip
      label="Validated"
      size="small"
      color="success"
      icon={<CheckIcon fontSize="small" />}
    />
  ) : (
    <Chip
      label="Not validated"
      size="small"
      color="warning"
      icon={<GppMaybeIcon fontSize="small" />}
    />
  );
